import ModalRandomMacWarning from './ModalRandomMacWarning';

export default ModalRandomMacWarning;
